import { render } from "./GetStarted.vue?vue&type=template&id=6d3c8fc4&scoped=true"
import script from "./GetStarted.vue?vue&type=script&lang=js"
export * from "./GetStarted.vue?vue&type=script&lang=js"

import "./GetStarted.vue?vue&type=style&index=0&id=6d3c8fc4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\McCoy\\Desktop\\Coding\\Work\\caby_landing_page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d3c8fc4"]])

export default __exports__